import Vue from 'vue';
import SignalRService from './signalR.service';
import './signalR.hooks';

Vue.prototype.$signalR = SignalRService;
